import script from "./SkinsMegaMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SkinsMegaMenu.vue?vue&type=script&setup=true&lang=js"

import "./SkinsMegaMenu.vue?vue&type=style&index=0&id=3d8f74fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d8f74fb"]])

export default __exports__